module.exports = __webpack_public_path__ + "img/icon-electricity.ef974f95.png";